export default __webpack_public_path__ + "static/media/Security.0253d221.svg";